import { z } from 'zod';

export const SalesPipelineContactStatusEnum = z.enum([
  'new',
  'awaiting_response',
  'active_conversation',
  'drafting',
  'contract_sent',
  'payment_pending',
  'deposit_received',
  'disqualified',
  'no_answer',
]);

export type SalesPipelineContactStatus = z.infer<
  typeof SalesPipelineContactStatusEnum
>;
